import { AnyAction } from 'redux';
import produce from 'immer';
import { reportV2Actions } from '../actions/reportsV2';
import { ReportV2State } from '../types/state';
import { get } from 'lodash';
import { InputValue } from '../components/UI/Inputs/Models';

const initialState: ReportV2State = {
  isLoading: false,
  offerCycles: undefined,
  leaseReportData: undefined,
  renewalReportData: undefined,
  selectedProperty: undefined,
  selectedMarket: undefined,
  exposureRentTrend: undefined,
  unitTypes: undefined,
  blendedGeneralReport: undefined,
};

const reportV2 = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case reportV2Actions.IS_LOADING: {
      return produce(state, (df) => {
        df.isLoading = action.payload;
      });
    }

    case reportV2Actions.SET_PROPERTY: {
      return produce(state, (df) => {
        const property = action.payload as InputValue;
        if (property.name.toLocaleLowerCase() === 'all') {
          df.selectedProperty = undefined;
        } else {
          df.selectedProperty = action.payload;
        }
      });
    }
    case reportV2Actions.SET_MARKET: {
      return produce(state, (df) => {
        const market = action.payload as InputValue;
        if (market.name.toLocaleLowerCase() === 'all') {
          df.selectedMarket = undefined;
        } else {
          df.selectedMarket = action.payload;
        }
      });
    }
    case reportV2Actions.SET_LEASE_REPORT_DATA: {
      return produce(state, (df) => {
        df.leaseReportData = action.payload;
      });
    }
    case reportV2Actions.SET_BLENDED_TRADEOUT_REPORT_DATA: {
      return produce(state, (df) => {
        df.blendedGeneralReport = action.payload;
      });
    }

    case reportV2Actions.SET_ALL_UNIT_TYPES: {
      return produce(state, (df) => {
        df.unitTypes = action.payload;
      });
    }

    case reportV2Actions.SET_EXPOSURE_RENT_TREND_REPORT: {
      return produce(state, (df) => {
        df.exposureRentTrend = action.payload.exposureRentTrend;
      });
    }

    case reportV2Actions.SET_RENEWAL_REPORT_DATA: {
      return produce(state, (df) => {
        df.renewalReportData = action.payload;
      });
    }

    case reportV2Actions.SET_OFFER_CYCLES: {
      const { lease, renewal } = action.payload;

      if (!lease || lease.length === 0 || !renewal || renewal.length === 0) {
        return state;
      }

      return produce(state, (df) => {
        df.offerCycles = {
          lease: get(lease[0], 'OfferCycle'),
          renewal: get(renewal[0], 'OfferCycle'),
        };
      });
    }

    // default states
    case 'INITIALIZE': {
      return state;
    }
    case 'LOGOUT': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default reportV2;
